<template>
  <div @contextmenu="selectComponentDEV($event, schema.model)" :class="['d-flex', getSelectedDEV && 'dev-selected-component']">
    <i4pro-icon-popover
      v-if="schema.attributesInfo"
      :class="[schema.attributesInfo.right ? 'ml-1 order-2' : 'mr-1']"
      :schema="schema"
      :model="model"
    ></i4pro-icon-popover>

    <v-menu :close-on-content-click="false" v-model="menu" v-bind="schema.attributesMenu">
      <template v-slot:activator="{ on }">
        <v-text-field
          v-bind="schema.attributesTextField"
          :disabled="schema.readonly"
          :value="formattedDate"
          :rules="rules"
          :name="schema.model"
          :id="setId(schema.model)"
          @click:clear="clear"
          @change="onChangeInput"
          v-on="on"
          v-mask="customMask"
        >
          <template v-slot:label>
            {{ schema.attributesTextField.label }}
            <span v-if="schema.rules.includes('required')" class="red--text">*</span>
          </template>
        </v-text-field>
      </template>

      <v-date-picker
        @change="onChange"
        @focus="onFocus"
        @input="menu = false"
        v-model="due"
        v-bind="schema.attributesDatePicker"
        :disabled="schema.readonly"
        v-if="!schema.attributesTextField.readonly"
      >
        <v-btn v-if="schema.btnShow" :text="schema.btnFlat" :color="schema.btnCancelColor" @click="menu = false">{{ schema.btnCancelLabel }}</v-btn>

        <v-btn v-if="schema.btnShow" :text="schema.btnFlat" :color="schema.btnSaveColor" @click="$refs.menu.save(value)">{{
          schema.btnSaveLabel
        }}</v-btn>
      </v-date-picker>
    </v-menu>
  </div>
</template>

<script>
import { abstractField } from 'vue-form-generator';
import devComponentMixin from '@/mixins/dev-component-mixin';
import rulesMixin from '@/mixins/rules-mixin';
import moment from 'moment';
import * as HANDLERS from '@/helpers/types/handlers';
import inputEventsMixin from '@/mixins/input-events-mixin';

export default {
  mixins: [abstractField, devComponentMixin, rulesMixin, inputEventsMixin],

  components: {
    i4proIconPopover: () => import('@/components/icons/i4pro-icon-popover')
  },

  data: () => ({
    menu: false,
    due: null,
    patternData: /^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-](19|20|21)\d{2}$/,
    dateInput: '',
    mask: /\d/,
    customTokens: {
      F: { pattern: /[0-2]/ }
    },
    customMask: {
      mask: 'D#/M#/####',
      tokens: {
        D: {
          pattern: /[0-3]/
        },
        M: { pattern: /[0-1]/ },
        '#': { pattern: /\d/ }
      }
    }
  }),

  computed: {
    formattedDate() {
      if (this.due == 'Invalid date') {
        this.due = new Date(moment().format('MM/DD/YYYY')).toISOString().substr(0, 10);
        this.value = new Date(moment().format('MM/DD/YYYY')).toISOString().substr(0, 10);
        return moment().format('DD/MM/YYYY');
      }

      if (this.due) return moment(this.due).format('DD/MM/YYYY');

      if (this.model && this.model[this.schema.model]) {
        this.due = new Date(this.model[this.schema.model]).toISOString().substr(0, 10);

        return moment(this.model[this.schema.model]).format('DD/MM/YYYY');
      }

      return '';
    }
  },

  watch: {
    value(newValue) {
      this.due = newValue ? moment(newValue).format('YYYY-MM-DD') : null;
    }
  },

  methods: {
    onChange: async function() {
      this.value = this.due;
      this.changeEvents();
    },

    onChangeInput(date) {
      if (date && this.patternData.test(date)) {
        let dateFormat = date.split('/');
        this.value = new Date(moment(`${dateFormat[2]}-${dateFormat[1]}-${parseInt(dateFormat[0])}`).format('MM/DD/YYYY'))
          .toISOString()
          .substr(0, 10);
      } else if (date == null) {
        this.due = null;
      } else {
        this.value = 'Invalid';
      }
    },

    clear() {
      this.$nextTick(() => (this.model[this.schema.model] = ''));
    },

    setId(field) {
      return this.formOptions.mode === 'list' ? `${field}_${this.formOptions.index}` : field;
    }
  }
};
</script>
